exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._199Bp{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._199Bp:hover{opacity:.7}._1jXeG{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}._1roEQ{position:absolute;z-index:55;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column-reverse;pointer-events:none;background-color:black;align-items:center}._2ZB7s{position:absolute;z-index:2;top:0;right:0;bottom:0;left:0;opacity:.5}\n", ""]);

// Exports
exports.locals = {
	"controlButton": "_199Bp",
	"hidden": "_1jXeG",
	"container": "_1roEQ",
	"frame": "_2ZB7s"
};